import { screenSmMin, spacer4, spacer12 } from '@spotify-internal/encore-foundation';
import { buttonHoverScale } from "../../styles/index.mjs";
import { ButtonTertiary } from "../ButtonTertiary/index.mjs";
import styled from "../../styled-components.mjs";
export var CloseButton = styled(ButtonTertiary).withConfig({
  displayName: "CloseButton",
  componentId: "sc-abn00m-0"
})(["position:absolute;right:", ";top:50%;transform:translate(0,-50%);[dir='rtl'] &{right:unset;left:", ";}@media (min-width:", "){right:", ";[dir='rtl'] &{left:", ";}}&:active{transform:translate(0,-50%) scale(1);}&:hover{transform:translate(0,-50%) scale(", ");}"], spacer4, spacer4, screenSmMin, spacer12, spacer12, buttonHoverScale);